'use strict';
import tracking from '@finn-no/analytics';

window.addEventListener('load', () => {
  tracking.trackPage();
});
